
import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Award, ArrowRight } from 'lucide-react';
import FadeIn from '../../components/FadeIn';
import SEO from '../../components/SEO';

const ExperiencedBdTraining = () => {
    return (
        <div className="bg-white">
            <SEO
                title="Experienced BD Track | BPO Consultants"
                description="Advanced training for seasoned sales professionals targeting international markets."
            />

            {/* Hero */}
            <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-[#0B0D15] overflow-hidden">
                <div className="absolute inset-0 opacity-20">
                    <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=1200" alt="Meeting" className="w-full h-full object-cover" />
                </div>
                <div className="max-w-7xl mx-auto relative z-10 text-center">
                    <FadeIn>
                        <span className="inline-block bg-[#A2CB52]/20 text-[#A2CB52] px-4 py-2 rounded-full text-sm font-bold border border-[#A2CB52]/40 mb-6 backdrop-blur-sm">
                            <Award size={14} className="inline mr-1" /> Executive Level
                        </span>
                        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
                            Experienced BD Track
                        </h1>
                        <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                            Refine your craft. Close bigger deals. Navigate complex stakeholders.
                        </p>
                    </FadeIn>
                </div>
            </section>

            {/* Content */}
            <section className="py-20 px-4 sm:px-6 lg:px-8">
                <div className="max-w-4xl mx-auto">
                    <FadeIn className="mb-16">
                        <h2 className="text-3xl font-bold text-[#20222D] mb-6">Advanced Curriculum</h2>
                        <p className="text-lg text-gray-600 leading-relaxed mb-6">
                            You already know how to sell. Now learn how to navigate enterprise organizations, manage complex sales cycles, and build long-term strategic partnerships with global clients.
                        </p>
                    </FadeIn>

                    <FadeIn className="grid md:grid-cols-2 gap-6 mb-16">
                        {[
                            { title: "Enterprise Account Mapping", path: "/training/experienced-bd/account-mapping", icon: <CheckCircle className="text-[#A2CB52] mr-3" size={24} /> },
                            { title: "Stakeholder Management", path: "/training/experienced-bd/stakeholder-management", icon: <CheckCircle className="text-[#A2CB52] mr-3" size={24} /> },
                            { title: "Advanced Negotiation Tactics", path: "/training/experienced-bd/negotiation-tactics", icon: <CheckCircle className="text-[#A2CB52] mr-3" size={24} /> },
                            { title: "Closing Six-Figure Deals", path: "/training/experienced-bd/closing-deals", icon: <CheckCircle className="text-[#A2CB52] mr-3" size={24} /> }
                        ].map((item, i) => (
                            <Link key={i} to={item.path} className="flex items-center bg-gray-50 p-6 rounded-xl border border-gray-100 hover:border-[#A2CB52] hover:shadow-md transition-all group">
                                {item.icon}
                                <span className="font-medium text-[#20222D] group-hover:text-[#A2CB52] transition-colors">{item.title}</span>
                                <ArrowRight className="ml-auto opacity-0 group-hover:opacity-100 text-[#A2CB52] transition-opacity" size={16} />
                            </Link>
                        ))}
                    </FadeIn>

                    <FadeIn className="bg-[#20222D] rounded-3xl p-12 text-center relative overflow-hidden">
                        <div className="absolute top-0 right-0 w-64 h-64 bg-[#A2CB52] blur-[100px] opacity-20 pointer-events-none"></div>
                        <h2 className="text-3xl font-bold text-white mb-6">Take the Next Step</h2>
                        <Link to="/contact" className="inline-flex items-center bg-[#A2CB52] text-[#20222D] px-8 py-4 rounded-xl font-bold text-lg hover:bg-[#B5D575] transition-all transform hover:scale-105">
                            Apply Now <ArrowRight className="ml-2" size={20} />
                        </Link>
                    </FadeIn>
                </div>
            </section>
        </div>
    );
};

export default ExperiencedBdTraining;
